<!-- 模拟试题 -->
<template>
<van-popup v-model="show" class="mnst-popup list-popup" position="right" :overlay-style="{background: '#fff'}">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">模拟试题</div>
    </div>
    <!-- <el-scrollbar class="subject-item-box">
        <div class="subject-item" @click="handleChangeActiveSubject(item)" v-for="(item) in tabList" :key="item.code" :class="{active: item.code === activeSubject.code}">{{ item.name }}</div>
    </el-scrollbar> -->
    <div class="subject-box">
        <div class="subject-name">{{ activeSubject.name }}</div>
        <div class="handle" @click="handleOpenChangeSubject">
            <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/change_icon.png')" />
            <div class="handle-label">切换科目</div>
        </div>
    </div>
    <van-list v-model="activeSubject.loadingmore" :finished="activeSubject.finished" class="content-scroll" @load="handleVanlistLoad" :offset="100" finished-text="已加载全部数据">
        <div class="placeholder"></div>
        <div class="ques-item" v-for="(item) in activeSubject.topicinfo.quesbanklist" :key="item.bankid">
            <div class="text-info">
                <div class="bankname text-ellipses">{{ item.bankname }}</div>
                <div class="data">
                    <div class="rightrate">{{ item.rightrate }}</div>
                    <div class="count">{{ item.finishquescount }}/{{ item.quescount }}</div>
                </div>
            </div>
            <div class="item-handle">
                <div class="lock-btn" v-if="!activeSubject.isjoin" @click="handleBuy">
                    <img class="lock-icon" :src="require('@/common/images/mSpecialTopic/lock_icon.png')" />
                    <div class="label">购买解锁</div>
                </div>
                <div v-else>
                    <img class="do-exam-icon" v-if="item.userexamstatus === 0" @click="handleUpdateStartExam(item)" :src="require('@/common/images/mSpecialTopic/do_exam_icon.png')" />
                    <div class="again-exam" v-if="item.userexamstatus === 10" @click="handleUpdateStartExam(item)">重做</div>
                    <div class="continue-exam" v-if="item.userexamstatus === 1" @click="handleContinueExam(item)">继续</div>
                </div>
            </div>
        </div>
    </van-list>
    <ChangeSubject ref="changeSubject" @handleSubjectChange="handleSubjectChange"></ChangeSubject>
</van-popup>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {getTopicQuesBankInfoV2} from '@/api/specialTopic.js'
import {updateStartExam} from '@/api/questionbank.js'
import {mapActions} from 'vuex'
import ChangeSubject from '../component/changeSubject.vue'
export default {
    data() {
        return {
            show: false,
            pageinfo: {
                page: 1,
                pagesize: 10
            },
            activeSubject: {
                code: this.$route.query.subjectcode ? this.$route.query.subjectcode : '',
                init: false,
                loadingmore: false,
                finished: false,
                topicinfo: {
                    pageinfo: {
                        pageCount: 1,
                        pageNum: 1,
                        pageSize: 10,
                        rowCount: 0
                    },
                    quesbanklist: [],
                    datatype: 0
                }
            },
            tabList: [],
            requestListIng: false
        }
    },
    props: {
        subjectList: {
            type: Array,
            required: true,
            default: () => {
                return specialTopic.subject[this.$route.params.examcode]
            }
        }
    },
    components: {
        ChangeSubject
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.show = true
            this.handleInit()
        },
        handleClose() {
            this.show = false
        },
        handleVanlistLoad() {
            if (this.activeSubject.init && !this.activeSubject.finished && this.pageinfo.page < this.activeSubject.topicinfo.pageinfo.pageCount) {
                this.pageinfo.page++
                this.handleGetTopicQuesBankInfoV2()
            }
        },
        handleChangeActiveSubject(item) {
            if (item.code !== this.activeSubject.code) {
                this.activeSubject = JSON.parse(JSON.stringify(item))
                if (!this.activeSubject.init) {
                    this.pageinfo.page = 1
                    this.handleGetTopicQuesBankInfoV2()
                } else {
                    this.pageinfo.page = this.activeSubject.topicinfo.pageinfo.pageNum
                }
            }
        },
        handleOpenChangeSubject() {
            this.$refs.changeSubject.handleOpen(this.$route.params.examcode, this.activeSubject.code)
        },
        handleSubjectChange(subjectcode) {
            if (subjectcode !== this.activeSubject.code) {
                this.tabList.some(item => {
                    if (item.code === subjectcode) {
                        this.handleChangeActiveSubject(item)
                        return true
                    }
                })
            }
        },
        handleInit() {
            if (!this.activeSubject.init) {
                this.pageinfo.page = 1
                this.handleGetTopicQuesBankInfoV2()
            }
        },
        handleGetTopicQuesBankInfoV2() {
            if (this.requestListIng) {
                return
            }
            this.requestListIng = true
            let params = {
                examcode: this.$route.params.examcode,
                subjectcode: this.activeSubject.code,
                sectioncode: '0103',
                page: this.pageinfo.page,
                pagesize: this.pageinfo.pagesize
            }
            if (params.page === 1) {
                this.setLoading(true)
            } else {
                this.activeSubject.loadingmore = true
            }
            getTopicQuesBankInfoV2({
                data: params,
                success: data => {
                    if (params.page === 1) {
                        this.activeSubject.topicinfo = data
                    } else {
                        this.activeSubject.topicinfo.quesbanklist = this.activeSubject.topicinfo.quesbanklist.concat(data.quesbanklist)
                    }
                    this.activeSubject.init = true
                    this.activeSubject.loadingmore = false
                    if (this.activeSubject.topicinfo.quesbanklist.length >= this.activeSubject.topicinfo.pageinfo.rowCount) {
                        this.activeSubject.finished = true
                    } else {
                        this.activeSubject.finished = false
                    }
                    this.tabList.some(item => {
                        if (item.code === this.activeSubject.code) {
                            item.init = true
                            item.topicinfo = JSON.parse(JSON.stringify(this.activeSubject.topicinfo))
                            item.loadingmore = false
                            item.finished = this.activeSubject.finished
                            return true
                        }
                    })
                    this.setLoading(false)
                    this.requestListIng = false
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                    this.requestListIng = false
                }
            })
        },
        handleBuy() {
            this.$emit('handleBuyTopic', this.activeSubject.code)
        },
        // 开始做题/重新做题
        handleUpdateStartExam(item) {
            this.setLoading(true)
            updateStartExam({
                data: {
                    topiccode: this.$route.params.examcode,
                    subjectcode: this.activeSubject.code,
                    sectioncode: '0103',
                    assetinnerid: item.bankid,
                    taskid: '',
                    examid: ''
                },
                success: data => {
                    this.setLoading(false)
                    item.userexamstatus = 1
                    item.userexamid = data.data
                    this.$router.push({
                        name: 'MSpecialTopicExam',
                        params: {
                            examsource: 4,
                            examcode: this.$route.params.examcode
                        },
                        query: {
                            examid: data.data,
                            subjectcode: this.activeSubject.code
                        }
                    })
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 继续做题/查看解析
        handleContinueExam(item) {
            this.$router.push({
                name: 'MSpecialTopicExam',
                params: {
                    examsource: 4,
                    examcode: this.$route.params.examcode
                },
                query: {
                    examid:item.userexamid,
                    subjectcode: this.activeSubject.code,
                    ischeck: item.userexamstatus === 10 ? 1 : 0
                }
            })
        },
        handleLoadMore() {
            this.pageinfo.page++
            this.handleGetTopicQuesBankInfoV2()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        subjectList: {
            handler(newV) {
                if (newV && newV.length) {
                    let subjectlist = JSON.parse(JSON.stringify(newV))
                    subjectlist.forEach(item => {
                        if (!item.topicinfo) {
                            item.init = false
                            item.list = []
                            item.loadingmore = false
                            item.finished = false
                            item.topicinfo = {
                                pageinfo: {
                                    pageCount: 1,
                                    pageNum: 1,
                                    pageSize: 10,
                                    rowCount: 0
                                },
                                quesbanklist: [],
                                datatype: 0
                            }
                        }
                    })
                    if (this.activeSubject.code) {
                        let flag = false
                        subjectlist.some(item => {
                            if (item.code === this.activeSubject.code) {
                                this.activeSubject = JSON.parse(JSON.stringify(item))
                                flag = true
                                return true
                            }
                        })
                        if (!flag) {
                            this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                        }
                    } else {
                        this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                    }
                    this.tabList = JSON.parse(JSON.stringify(subjectlist))
                }
            },
            deep: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.mnst-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .subject-item-box {
        height: 0.8rem;
        .el-scrollbar__view {
            display: flex;
            height: 0.8rem;
            .subject-item {
                padding: 0 0.35rem;
                line-height: 0.8rem;
                font-size: 0.3rem;
                color: #333333;
                white-space: nowrap;
                background: #fff;
                &.active {
                    color: #1D60AD;
                    background: rgba(29,96,173,0.1);
                    font-weight: bold;
                }
            }
        }
    }
    .subject-box {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.28rem;
        box-sizing: border-box;
        background: #fff;
        .subject-name {
            font-size: 0.3rem;
            color: #333333;
            font-weight: bold;
        }
        .handle {
            display: flex;
            align-items: center;
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.08rem;
            }
            .handle-label {
                font-size: 0.26rem;
                color: #666666;
            }
        }
    }
    .content-scroll {
        height: calc(100vh - 0.88rem - 0.8rem);
        overflow-y: scroll;
        .placeholder {
            height: 0.2rem;
        }
        .ques-item {
            padding: 0.28rem 0.32rem;
            box-sizing: border-box;
            background: #fff;
            margin-bottom: 0.12rem;
            display: flex;
            align-items: center;
            .text-info {
                flex: 1;
                width: 0;
                margin-right: 0.88rem;
                .bankname {
                    font-size: 0.3rem;
                    color: #333333;
                    line-height: 0.42rem;
                    margin-bottom: 0.1rem;
                }
                .data {
                    display: flex;
                    align-items: center;
                    .rightrate, .count {
                        font-size: 0.24rem;
                        color: #999999;
                        line-height: 0.34rem;
                    }
                    .rightrate {
                        margin-right: 0.2rem;
                    }
                }
            }
            .item-handle {
                width: 1rem;
                height: 0.54rem;
                .lock-btn {
                    .lock-icon {
                        width: 0.38rem;
                        height: 0.38rem;
                        margin: 0 auto 0.04rem;
                    }
                    .label {
                        font-size: 0.22rem;
                        color: #999999;
                        line-height: 0.3rem;
                    }
                }
                .do-exam-icon {
                    width: 0.46rem;
                    height: 0.46rem;
                    margin: 0 auto;
                }
                .again-exam {
                    width: 0.98rem;
                    height: 0.54rem;
                    background: #1D60AD;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 0.24rem;
                }
                .continue-exam {
                    width: 0.98rem;
                    height: 0.54rem;
                    background: #fff;
                    border: 0.02rem solid #1D60AD;
                    box-sizing: border-box;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #1D60AD;
                    font-size: 0.24rem;
                }
            }
        }
    }
}
</style>